import { PrimaryInfo } from './../util';
import { CoordinationGroup } from "../../models/CoordinationGroup";

export const getSuggestion = (cg: CoordinationGroup): PrimaryInfo => {
    return {
        name: cg.name,
        id: cg.id
    };
};
